export default {
  async updateFile({ file, container, options = {} }) {
    const containerURL = new window.azblob.ContainerURL(
      `${process.env.VUE_APP_CDN_BLOBURI}/${container}${process.env.VUE_APP_CDN_SASTOKEN}`,
      window.azblob.StorageURL.newPipeline(
        new window.azblob.AnonymousCredential()
      )
    );
    try {
      const nameFile = `${this.generateUuid(file.name.split(".")[0])}.${file.name.split(".")[1]}`;
      const blockBlobURL = window.azblob.BlockBlobURL.fromContainerURL(
        containerURL,
        nameFile
      );

      // check content type
      if (!options.hasOwnProperty("blobHTTPHeaders")) {
        this.populateHeaders(file, options);
      }

      await window.azblob.uploadBrowserDataToBlockBlob(
        window.azblob.Aborter.none,
        file,
        blockBlobURL,
        options
      );
      return nameFile;
    } catch (error) {
      console.error(error);
    }
  },
  generateUuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  },
  populateHeaders(file, options) {
    const [ext] = file.name.split(".").slice(-1);

    options.blobHTTPHeaders = {};
    switch (ext) {
      case "jpeg":
      case "jpg":
        options.blobHTTPHeaders.blobContentType = "image/jpeg";
        break;
      case "png":
        options.blobHTTPHeaders.blobContentType = "image/png";
        break;
      case "gif":
        options.blobHTTPHeaders.blobContentType = "image/gif";
        break;
      case "svg":
        options.blobHTTPHeaders.blobContentType = "image/svg+xml";
        break;
      case "ico":
        options.blobHTTPHeaders.blobContentType = "image/x-icon";
        break;
      case "json":
        options.blobHTTPHeaders.blobContentType = "application/json";
        break;
      default:
        options.blobHTTPHeaders.blobContentType = "application/octet-stream";
        break;
    }

    return options;
  }
};
